<div class="acc-status" *ngIf="presence$ | async as userStatus" [ngClass]="{
    'is-success':  userStatus.status  === 'online',
    'is-away':userStatus.status  === 'away'
}"></div>